import LanguageIcon from '@material-ui/icons/Language';
import FaceIcon from '@material-ui/icons/Face';
import AccessibilityNewIcon from '@material-ui/icons/AccessibilityNew';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import CommuteIcon from '@material-ui/icons/Commute';
import RingVolumeIcon from '@material-ui/icons/RingVolume';
import SettingsPhoneIcon from '@material-ui/icons/SettingsPhone';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import ListAltIcon from '@material-ui/icons/ListAlt';
import ListIcon from '@material-ui/icons/List';
import AvTimerIcon from '@material-ui/icons/AvTimer';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { translate } from '../../../../ts-helpers/util';
import BallotIcon from '@material-ui/icons/Ballot';
import {
  departmentImagePath,
  insuranceImagePath,
  languageImagePath,
} from '../../../../ts-helpers/imagePaths';
import SecurityIcon from '@material-ui/icons/Security';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CallMergeIcon from '@material-ui/icons/CallMerge';
import PersonPinIcon from '@material-ui/icons/PersonPin';
import AccessibleForward from '@material-ui/icons/AccessibleForward';
import EventNoteIcon from '@material-ui/icons/EventNote';

export const leftBarSettingsItems = [
  // Languages
  {
    isExpanding: true,
    permissionName: 'language',
    allLinkName: 'dashboard_language_all',
    sectionIcon: <LanguageIcon />,
    sectionTitleTKey: 'languages_table_hide_languages',
    addLinkName: 'dashboard_language_add',
    addTitleTKey: 'right_menu_tool_add_new_language',
    itemLinkName: 'dashboard_language_edit',
    itemLinkParamName: 'languageId',
    getText: (item) => item.name,
    fetchUrl: '/admin/languages-show-hide',
    icon: (item) => <img src={languageImagePath(item.flag)} alt={item.flag} />,
  },
  //Departments
  {
    isExpanding: true,
    permissionName: 'department',
    allLinkName: 'dashboard_department_all',
    sectionIcon: <ViewComfyIcon />,
    sectionTitleTKey: 'right_menu_link_departments',
    addLinkName: 'dashboard_department_add',
    addTitleTKey: 'right_menu_tool_add_new_department',
    itemLinkName: 'dashboard_department',
    itemLinkParamName: 'departmentId',
    getText: (item) => item.name,
    fetchUrl: '/admin/departments-right-menu',
    icon: (item) => (
      <img
        style={{ background: item.color }}
        className="imageLogo"
        src={departmentImagePath(item.image)}
        alt="Departments"
      />
    ),
  },
  //Roles
  {
    isExpanding: true,
    permissionName: 'role',
    allLinkName: 'dashboard_role_all',
    sectionIcon: <FaceIcon />,
    sectionTitleTKey: 'right_menu_link_roles',
    addLinkName: 'dashboard_role_add',
    addTitleTKey: 'right_menu_tool_add_new_role',
    itemLinkName: 'dashboard_role',
    itemLinkParamName: 'roleId',
    getText: (item) => item.name,
    fetchUrl: '/admin/roles',
    icon: (item) => <AccessibilityNewIcon style={{ background: item.color }} />,
  },
  //Auto Types
  {
    isInfinite: true,
    isExpanding: true,
    permissionName: 'auto-type',
    allLinkName: 'dashboard_autotype_all',
    sectionIcon: <DirectionsCarIcon />,
    sectionTitleTKey: 'right_menu_link_vehicle_type',
    addLinkName: 'dashboard_autotype_add',
    addTitleTKey: 'right_menu_tool_add_new_vehicle_type',
    itemLinkName: 'dashboard_autotype',
    itemLinkParamName: 'autotypeId',
    getText: (item) => item.name,
    fetchUrl: '/admin/auto-types-right-menu',
    icon: () => <CommuteIcon />,
  },

  // Driver Events
  {
    permissionName: 'driver-events',
    allLinkName: 'dashboard_driver_events_all',
    sectionIcon: <EventNoteIcon />,
    sectionTitleTKey: 'right_menu_link_driver_events',
  },

  // Vehicle Equipment
  {
    permissionName: 'vehicle-equipment',
    allLinkName: 'dashboard_vehicle_equipment_all',
    sectionIcon: <AddShoppingCartIcon />,
    sectionTitleTKey: 'right_menu_link_vehicle_equipment',
  },

  // // Vehicle Capacity Type
  // {
  //     permissionName: "vehicle-capacity-type",
  //     allLinkName: "dashboard_vehicle_capacity_type_all",
  //     sectionIcon: <AccessibleForward />,
  //     sectionTitleTKey: "right_menu_link_vehicle_capacity_type",
  // },

  // Vehicle Capacity
  {
    permissionName: 'vehicle-capacity',
    allLinkName: 'dashboard_vehicle_capacity_all',
    sectionIcon: <PersonPinIcon />,
    sectionTitleTKey: 'right_menu_link_vehicle_capacity',
  },

  //Insurances
  {
    isExpanding: true,
    permissionName: 'insurance',
    allLinkName: 'dashboard_insurance_all',
    sectionIcon: <SecurityIcon />,
    sectionTitleTKey: 'right_menu_link_insurance',
    addLinkName: 'dashboard_insurance_add',
    addTitleTKey: 'right_menu_tool_add_new_insurance',
    itemLinkName: 'dashboard_insurance',
    itemLinkParamName: 'insuranceId',
    getText: (item) => item.name,
    fetchUrl: '/admin/insurances-right-menu',
    icon: (item) => (
      <img
        style={{ background: item.color }}
        className="imageLogo"
        src={insuranceImagePath(item.logo)}
        alt="Insurances"
      />
    ),
  },
  //Mobile Providers,
  {
    isInfinite: true,
    isExpanding: true,
    permissionName: 'mobile-provider',
    allLinkName: 'dashboard_mobileprovider_all',
    sectionIcon: <RingVolumeIcon />,
    sectionTitleTKey: 'right_menu_link_mobile_providers',
    addLinkName: 'dashboard_mobileprovider_add',
    addTitleTKey: 'right_menu_tool_add_new_mobile_provider',
    itemLinkName: 'dashboard_mobileprovider',
    itemLinkParamName: 'mobileproviderId',
    getText: (item) => item.name,
    fetchUrl: '/admin/mobile-providers-right-menu',
    icon: () => <SettingsPhoneIcon />,
  },
  //File Types,
  {
    isInfinite: true,
    isExpanding: true,
    permissionName: 'file-type',
    allLinkName: 'dashboard_filetype_all',
    sectionIcon: <FileCopyIcon />,
    sectionTitleTKey: 'right_menu_link_file_types',
    addLinkName: 'dashboard_filetype_add',
    addTitleTKey: 'right_menu_tool_add_new_file_type',
    itemLinkName: 'dashboard_filetype_edit',
    itemLinkParamName: 'filetypeId',
    getText: (item) => item.translation.translation,
    fetchUrl: '/admin/file-types-right-menu',
    icon: () => <InsertDriveFileIcon />,
  },
  //Forms
  {
    isInfinite: true,
    isExpanding: true,
    permissionName: 'form-settings',
    allLinkName: 'dashboard_forms_all',
    sectionIcon: <ListAltIcon />,
    sectionTitleTKey: 'right_menu_link_forms',
    itemLinkName: 'dashboard_form_settings',
    itemLinkParamName: 'formId',
    getText: (item) => translate(item.name),
    fetchUrl: '/admin/forms-right-menu',
    icon: () => <ListIcon />,
  },
  //Status
  {
    permissionName: 'status',
    allLinkName: 'dashboard_status_all',
    sectionIcon: <AvTimerIcon />,
    sectionTitleTKey: 'right_menu_link_status',
  },
  //API Tokens
  {
    permissionName: 'api-tokens',
    allLinkName: 'dashboard_api_tokens_all',
    sectionIcon: <VpnKeyIcon />,
    sectionTitleTKey: 'right_menu_link_api_tokens',
  },
  //Patient Cancel Reasons
  {
    permissionName: 'patient-cancel-reason',
    allLinkName: 'dashboard_cancelreason_all',
    sectionIcon: <BallotIcon />,
    sectionTitleTKey: 'right_menu_link_cancel_reason',
    addLinkName: 'dashboard_cancelreason_add',
    addTitleTKey: 'right_menu_tool_add_new_cancel_reason',
    itemLinkName: 'dashboard_cancelreason',
    itemLinkParamName: 'cancelreasonId',
    getText: (item) => item.translation.translation,
  },
  //Driver Decline Reasons
  {
    permissionName: 'driver-decline-reason',
    allLinkName: 'dashboard_declinereason_all',
    sectionIcon: <BallotIcon />,
    sectionTitleTKey: 'right_menu_link_decline_reason',
    addLinkName: 'dashboard_declinereason_add',
    addTitleTKey: 'right_menu_tool_add_new_decline_reason',
    itemLinkName: 'dashboard_declinereason',
    itemLinkParamName: 'declinereasonId',
    getText: (item) => item.translation.translation,
  },
  //Zip Code Group
  {
    permissionName: 'zip-code',
    allLinkName: 'dashboard_zip_code_groups_all',
    sectionIcon: <MailOutlineIcon />,
    sectionTitleTKey: 'right_menu_link_zip_code_groups',
  },
  //Routes
  {
    permissionName: 'routes',
    allLinkName: 'dashboard_routes',
    sectionIcon: <AccountTreeIcon />,
    sectionTitleTKey: 'right_menu_routes_groups',
  },
  //Daily Shared Rides
  {
    permissionName: 'routes',
    allLinkName: 'dashboard_daily_shared_rides',
    sectionIcon: <CallMergeIcon />,
    sectionTitleTKey: 'right_menu_shared_rides_groups',
  },
];
